export default class PictureHtml {
    constructor(xs, md, xl, alt, pictureClass) {
        this._xs = xs;
        this._md = md;
        this._xl = xl;
        this._alt = alt;
        this._pictureClass = pictureClass;
    }

    getDefaultImage() {
        const pictureXS = 'https://dev.karlstorz.dus.intentive.de/static_test/file_pics/pic_editorial/de/card-small-1x.jpg';
        const pictureMD = 'https://dev.karlstorz.dus.intentive.de/static_test/file_pics/pic_editorial/de/card-small-1x.jpg';
        const pictureXL = 'https://dev.karlstorz.dus.intentive.de/static_test/file_pics/pic_editorial/de/card-small-1x.jpg';

        let img = '';

        if ('objectFit' in document.documentElement.style === false) {
            img += `
                <div class="${this._pictureClass}__content-ie">
                    <picture class="${this._pictureClass}">
                        <source media="(min-width: 999px)" data-srcset="${pictureXL} 1x, ${pictureXL} 2x">
                        <source media="(min-width: 797px)" data-srcset="${pictureMD} 1x, ${pictureMD} 2x" >
                        <source data-srcset="${pictureXS} 1x, ${pictureXS} 2x" >
                        <img src="${pictureXS}" alt="${this._alt}" class="lazy" data-object-fit="contain" >
                    </picture>
                </div>
            `;
        } else {
            img += `
                <div class="${this._pictureClass}__content">
                    <picture class="${this._pictureClass}">
                        <source media="(min-width: 999px)" data-srcset="${pictureXL} 1x, ${pictureXL} 2x">
                        <source media="(min-width: 797px)" data-srcset="${pictureMD} 1x, ${pictureMD} 2x" >
                        <source data-srcset="${pictureXS} 1x, ${pictureXS} 2x" >
                        <img src="${pictureXS}" alt="${this._alt}" class="lazy" data-object-fit="contain" >
                    </picture>
                </div>
            `;
        }

        return img;
    }

    toString() {
        // eslint-disable-next-line no-undef
        const $globalConfig = config;

        let img = '';
        let pictureXS = $globalConfig.images.cardPictureXS;
        let pictureMD = $globalConfig.images.cardPictureMD;
        let pictureXL = $globalConfig.images.cardPictureXL;

        pictureXS = $globalConfig.urls.mediaFilesURL + this._xs;
        pictureMD = $globalConfig.urls.mediaFilesURL + this._md;
        pictureXL = $globalConfig.urls.mediaFilesURL + this._xl;

        if ('objectFit' in document.documentElement.style === false) {
            img += `<div class="rfct-product-card-small__content-ie">
                <picture class="rfct-product-card-small__image">
                    <source media="(min-width: 999px)" data-srcset="${pictureXL} 1x, ${pictureXL} 2x">
                    <source media="(min-width: 797px)" data-srcset="${pictureMD} 1x, ${pictureMD} 2x" >
                    <source data-srcset="${pictureXS} 1x, ${pictureXS} 2x" >
                    <img src="${pictureXS}" alt="${this._alt}" class="lazy" data-object-fit="contain" >
                </picture></div>`;
        } else {
            img += `<div class="product-card__visual product-card__visual--frame">
                <picture class="rfct-product-card-small__image picture">
                    <source media="(min-width: 999px)" data-srcset="${pictureXL} 1x, ${pictureXL} 2x">
                    <source media="(min-width: 797px)" data-srcset="${pictureMD} 1x, ${pictureMD} 2x" >
                    <source data-srcset="${pictureXS} 1x, ${pictureXS} 2x" >
                    <img src="${pictureXS}" alt="${this._alt}" class="lazy" data-object-fit="contain" >
                </picture></div>`;
        }

        return img;
    }
}
